import React from 'react';
import { ThemeProps, useTheme } from 'styled-components';

type ButtonCornersType = {
  errorStatus?: boolean;
};
const ButtonCorners: React.FC<ButtonCornersType> = ({ errorStatus }) => {
  const theme = useTheme();
  return (
    <>
      <svg
        className="Top-Left"
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13 1.96387L1 1.96387L1 13.9639"
          stroke={theme.colors.normalText}
          strokeWidth="2"
        />
      </svg>
      <svg
        className="Top-Right"
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.29864e-07 1.96387L12 1.96387L12 13.9639"
          stroke={theme.colors.normalText}
          strokeWidth="2"
        />
      </svg>
      <div>
        <svg
          className="Bottom-Left"
          width="13"
          height="14"
          viewBox="0 0 13 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13 12.9648H1V0.964844"
            stroke={theme.colors.normalText}
            strokeWidth="2"
          />
        </svg>

        <svg
          className="Bottom-Right"
          width="13"
          height="14"
          viewBox="0 0 13 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 12.9648H12V0.964844"
            stroke={theme.colors.normalText}
            strokeWidth="2"
          />
        </svg>
      </div>
    </>
  );
};

export default ButtonCorners;
